import { render, staticRenderFns } from "./FooterSite.vue?vue&type=template&id=2229ae70&"
import script from "./FooterSite.vue?vue&type=script&lang=js&"
export * from "./FooterSite.vue?vue&type=script&lang=js&"
import style0 from "./FooterSite.vue?vue&type=style&index=0&id=2229ae70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports